const pluralRules = new Intl.PluralRules('pt-BR')

const formatPluralLabel = (value, singular, plural) => {
  const rule = pluralRules.select(value)
  const label = rule === 'one' ? singular : plural

  return `${value} ${label}`
}

export { formatPluralLabel }
